var bighouse = bighouse || {};

bighouse.lightbox = (function () {
    var lastFocus;
    var lightboxOpen = false;
    var lightboxCount = 0;

    function init() {
        bindEvents();
    }

    function bindEvents() {

        lightboxBind();

        $('.js-lightboxClose').on('click', function (e) {
            close(e);
            e.preventDefault();
        });


        $('.Lightbox').on('click', function(e){
            if( $(e.target).hasClass('Lightbox--current') ){
                close(e);
            }
        });

    }

    function lightboxOpenFunc(e) {
        open($(e.currentTarget).attr('data-lightbox'), e.currentTarget);
        e.preventDefault();
    }

    function lightboxBind() {
        $('.js-lightboxOpen').on('click', lightboxOpenFunc);
    }

    function lightboxOff() {
        $('.js-lightboxOpen').off('click', lightboxOpenFunc);
    }

    function open(lightboxID, currentTarget) {

        // store the last place the user opened the lightbox from
        if (lightboxCount === 0 && currentTarget === null) //only if haven't already stored this ie no other lightbox is open
            lastFocus = document.activeElement;
        else if (currentLightbox !== null)
            lastFocus = currentTarget;

        lightboxCount++;

        if ((/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i).test(navigator.userAgent || navigator.vendor || window.opera)) {
            $('.Lightbox').addClass('fixfixed');
        }



        $('body, html').addClass('noscroll');
                
        var currentLightbox = $('#' + lightboxID);
        currentLightbox.addClass('Lightbox--current');
        currentLightbox.attr('aria-hidden', 'false');
        lightboxOpen = true;
        currentLightbox.find('.Lightbox-content').attr('tabindex', '0').focus();


    }

    function close(e) {

        if (lightboxOpen && (!e.keyCode || e.keyCode === 27) && !( !e.keyCode && e.type == 'keydown' )) {

            $('body, html').removeClass('noscroll');
            $('.Lightbox--current').removeClass('Lightbox--current');

            $('.Lightbox, .Drawer').attr('aria-hidden', 'true');
            $('.Lightbox-content, .Drawer-content').attr('tabindex', '-1');
            lightboxOpen = false;
            if(lastFocus !== null)
                lastFocus.focus();
        }       

        lightboxCount = $('.Lightbox--current').length;
    }




    return {
        init: init,
        open: open,
        close: close,
        lightboxBind: lightboxBind,
        lightboxOff: lightboxOff,
        lightboxOpenFunc: lightboxOpenFunc
    };
})();